import {Config} from '../../shared/types';
import {httpGetJson} from './http';
import once from 'lodash/once';

export const fetchConfig = once(() =>
  httpGetJson<Config>({path: '/datetime-ui/config'}),
);
